import axiosClient from './axiosClient';
import { IParamsGetProjects, IResponseGetProject } from '~/utils/interface/project';
import { IApiBaseResponse } from '~/utils/interface/common';

const projectApi = {
  getLists(params: IParamsGetProjects) {
    const url = `api/admin/projects`;
    return axiosClient.get<IApiBaseResponse<IResponseGetProject>>(url, { params });
  },
};

export default projectApi;
